module.exports = __webpack_public_path__ + "static/p2-a182c046950c418bcaf3ec7660e77f96.jpg";